/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from 'react'
import { Link } from 'react-router-dom'
import Dropdown from 'react-bootstrap/Dropdown'
import { DropdownTopbarItemToggler } from '../../../../_partials/dropdowns'
import { roleLabel, useAuthUser } from '../../../../../app/hooks/useIsAdmin'

const BRAND_BLUE = '#005BAA'

export function UserProfileDropdown() {
	const user = useAuthUser()
	const { fullName = 'Usuario', email = '', role } = user || {}
	const initial = (fullName || 'U').trim().charAt(0).toUpperCase()

	return (
		<Dropdown drop="down" alignRight>
			<Dropdown.Toggle
				as={DropdownTopbarItemToggler}
				id="dropdown-toggle-user-profile"
			>
				<div
					className={
						'btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2'
					}
				>
					<span className="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">
						Hola,
					</span>{' '}
					<span className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
						{fullName}
					</span>
					<span className="symbol symbol-35 symbol-light-primary">
						<span className="symbol-label font-size-h5 font-weight-bold">
							{initial}
						</span>
					</span>
				</div>
			</Dropdown.Toggle>
			<Dropdown.Menu className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
				<div
					className="d-flex align-items-center justify-content-between flex-wrap p-8 rounded-top"
					style={{ backgroundColor: BRAND_BLUE }}
				>
					<div className="symbol bg-white-o-15 mr-3">
						<span className="symbol-label text-white font-weight-bold font-size-h4">
							{initial}
						</span>
					</div>
					<div className="text-white m-0 flex-grow-1 mr-3">
						<div className="font-size-h5">{fullName}</div>
						{email && <div className="font-size-sm opacity-70">{email}</div>}
						<div className="font-size-sm font-weight-bold mt-1">
							{roleLabel(role)}
						</div>
					</div>
				</div>

				<div className="navi navi-spacer-x-0">
					<div className="navi-footer px-8 py-5">
						<Link
							to="/logout"
							className="btn btn-light-primary font-weight-bold"
						>
							Cerrar sesión
						</Link>
					</div>
				</div>
			</Dropdown.Menu>
		</Dropdown>
	)
}
